// Whether Clerk (auth for the /learn LMS section) is actually configured in
// this environment. Until a real key is set, ClerkProvider is not mounted at
// all (see index.js) -- LMS routes render a "not configured yet" fallback
// (see App.js) instead of the real pages, rather than crashing on a missing
// publishableKey. Every non-LMS page is unaffected either way.
export const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '';
export const CLERK_CONFIGURED = Boolean(CLERK_PUBLISHABLE_KEY);
